export default "__VITE_ASSET__BSoKvoyG__"